var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable tailwindcss/no-arbitrary-value */
import React from 'react';
import { Typography, ProgressBar, Popover, Alert, } from '@one-thd/sui-atomic-components';
import { RewardCardContainer, ButtonViewPerkOptions, ButtonViewPerksHistory, TileIcon, } from '../../../shared/rewards-hub';
import { InfoPerksContext, InfoRewardsContext, RewardsAndOffersContext, } from '../../../../contexts';
import { rhGeneral } from '../../../../constants/RewardsHub';
import { useIsMobile, useIsTablet } from '../../../../hooks';
import { PxccMultiplierIcon } from '../../../../images';
import { floorNumberWithCommas } from '../../../Utils';
var iconConstants = rhGeneral.assets;
var useGetIsMobile = function () { return useIsMobile().isMobile; };
var useGetIsTablet = function () { return useIsTablet().isTablet; };
var Badge4x = function () {
    return (React.createElement("span", { className: "sui-inline-flex sui-gap-1 sui-items-end" },
        React.createElement("span", { style: { marginRight: '2px' } }, "with"),
        React.createElement(PxccMultiplierIcon, { isBorderless: true, diameter: 20, fontSizeClass: "sui-text-xs" })));
};
var WellDoneTrackerTile = function (_a) {
    var firstName = _a.firstName;
    return (React.createElement("div", { className: "sui-inline-flex sui-mb-8" },
        React.createElement("div", { className: "sui-mr-6 sui-pt-1 sui-ml-1 sui-mb-2" },
            React.createElement(TileIcon, { iconUrl: iconConstants.ProXtraPerks })),
        React.createElement("div", null,
            React.createElement(Typography, { variant: "body-base", weight: "bold" },
                "Well done, ",
                firstName,
                "!"),
            React.createElement("p", { className: "sui-font-regular sui-text-base sui-tracking-normal sui-normal-case sui-line-clamp-unset sui-text-primary sui-mb-1" }, "Thank you for being a loyal Home Depot Customer."))));
};
var ProgressTrackerTile = function (_a) {
    var amount = _a.amount, accrual = _a.accrual, acceleratedAccrual = _a.acceleratedAccrual, percentage = _a.percentage, startLabel = _a.startLabel, endLabel = _a.endLabel, isMobile = _a.isMobile, viewingPxcc = _a.viewingPxcc;
    var _b = React.useState(null), anchorEl = _b[0], setAnchorEl = _b[1];
    var isTablet = useGetIsTablet();
    var handleClick = function (event) {
        setAnchorEl(event.currentTarget);
    };
    var handleClose = function () {
        setAnchorEl(null);
    };
    var open = Boolean(anchorEl);
    var id = open ? 'simple-popover' : undefined;
    var trackerData = {
        id: id,
        percentage: percentage,
        startLabel: startLabel,
        endLabel: endLabel,
        handleClick: handleClick,
        open: open,
        anchorEl: anchorEl,
        accrual: accrual,
        acceleratedAccrual: acceleratedAccrual,
        viewingPxcc: viewingPxcc,
        handleClose: handleClose,
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "sui-inline-flex sui-items-end sui-mb-2 sui-gap-x-2" },
            React.createElement(Typography, { variant: "h1" },
                "$",
                amount,
                " "),
            ' ',
            !isTablet && !isMobile && (React.createElement("p", { className: "sui-font-regular sui-text-base sui-tracking-normal sui-normal-case sui-line-clamp-unset sui-text-primary sui-mb-1" },
                "spend to unlock the next perk ",
                viewingPxcc && React.createElement(Badge4x, null)))),
        (isTablet || isMobile) && (React.createElement("div", { className: "sui-mb-2" },
            React.createElement("p", { className: "sui-font-regular sui-text-base sui-tracking-normal sui-normal-case sui-line-clamp-unset sui-text-primary sui-mb-1" },
                "spend to unlock the next perk ",
                viewingPxcc && React.createElement(Badge4x, null)))),
        React.createElement(PerkTrackerBar, __assign({}, trackerData))));
};
export var PerkTrackerBar = function (_a) {
    var id = _a.id, percentage = _a.percentage, startLabel = _a.startLabel, endLabel = _a.endLabel, handleClick = _a.handleClick, open = _a.open, anchorEl = _a.anchorEl, accrual = _a.accrual, acceleratedAccrual = _a.acceleratedAccrual, viewingPxcc = _a.viewingPxcc, handleClose = _a.handleClose;
    var percentageNum = Number(percentage);
    return (React.createElement("div", { className: "sui-w-full sui-flex sui-justify-between sui-mb-8" },
        React.createElement(ProgressBar, { component: "button", "aria-describedby": id, value: percentageNum, size: "large", startLabel: "$".concat(startLabel), endLabel: "$".concat(endLabel), labelPlacement: "inline", onClick: handleClick }),
        React.createElement(Popover, { id: id, open: open, anchorEl: anchorEl, onClose: handleClose, placement: "top" },
            React.createElement(Typography, null,
                "Perk Spend",
                React.createElement("strong", null,
                    " $",
                    viewingPxcc ? acceleratedAccrual : accrual)))));
};
export var ProgressBarCTA = function (_a) {
    var isMobile = _a.isMobile, showHistory = _a.showHistory;
    return !isMobile ? (React.createElement("div", { className: "sui-flex sui-gap-3 sui-w-full" },
        React.createElement(ButtonViewPerkOptions, null),
        showHistory && React.createElement(ButtonViewPerksHistory, null))) : (React.createElement("div", { className: "sui-w-full" },
        React.createElement("div", { className: "sui-mb-3 sui-mt-2" },
            React.createElement(ButtonViewPerkOptions, null)),
        showHistory && React.createElement(ButtonViewPerksHistory, null)));
};
export var PerkTrackerCTA = function (_a) {
    var isMobile = _a.isMobile, showHistory = _a.showHistory, finalTierPerkAchieved = _a.finalTierPerkAchieved;
    if (finalTierPerkAchieved && showHistory) {
        return React.createElement(ButtonViewPerksHistory, null);
    }
    return !isMobile ? (React.createElement("div", { className: "sui-flex sui-gap-3 sui-w-full" },
        React.createElement(ButtonViewPerkOptions, null),
        showHistory && React.createElement(ButtonViewPerksHistory, null))) : (React.createElement("div", { className: "sui-w-full" },
        React.createElement("div", { className: "sui-mb-3 sui-mt-2" },
            React.createElement(ButtonViewPerkOptions, null)),
        showHistory && React.createElement(ButtonViewPerksHistory, null)));
};
var ErrorTrackerTile = function (_a) {
    var refreshPerks = _a.refreshPerks;
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "sui-mb-8 sui-grow" },
            React.createElement(Alert, { status: "error" },
                React.createElement("p", null, "Something went wrong. Please refresh to see progress to your Next Perk."),
                React.createElement("button", { type: "button", onClick: refreshPerks },
                    React.createElement("u", null, "Refresh"))))));
};
export var PerkTracker = function () {
    var _a;
    var isMobile = useGetIsMobile();
    var _b = React.useContext(RewardsAndOffersContext), rewardsAndOffers = _b.rewardsAndOffers, generalError = _b.generalError, isChildAccount = _b.isChildAccount;
    // Through line 243 needs to be refactored when Blended rewards is confirmed
    var _c = React.useContext(InfoPerksContext), tempPerksInfo = _c.perksInfo, perksError = _c.hasError, tempRefreshPerks = _c.refreshPerks;
    var _d = React.useContext(InfoRewardsContext), rewardsInfo = _d.rewardsInfo, rewardsError = _d.hasError, isBlendedRewardsEnabled = _d.isBlendedRewardsEnabled, refreshRewards = _d.refreshRewards;
    var perksInfo = isBlendedRewardsEnabled ? rewardsInfo : tempPerksInfo;
    var hasError = isBlendedRewardsEnabled ? rewardsError : perksError;
    var refreshPerks = isBlendedRewardsEnabled
        ? refreshRewards
        : tempRefreshPerks;
    var userProfile = rewardsAndOffers === null || rewardsAndOffers === void 0 ? void 0 : rewardsAndOffers.userProfile;
    var customerInfo = rewardsAndOffers === null || rewardsAndOffers === void 0 ? void 0 : rewardsAndOffers.customerInfo;
    var pxccUserCategory = (customerInfo || {}).pxccUserCategory;
    var perkCurrentTierProgressPercentage = ((rewardsAndOffers === null || rewardsAndOffers === void 0 ? void 0 : rewardsAndOffers.perkAccrualSummary) || {}).perkCurrentTierProgressPercentage;
    var name = (userProfile || {}).name;
    var firstName = (name || {}).firstName;
    var _e = perksInfo || {}, currentTierId = _e.currentTierId, program = _e.program;
    var tiers = program === null || program === void 0 ? void 0 : program.tiers;
    var tierIdx = tiers === null || tiers === void 0 ? void 0 : tiers.findIndex(function (tier) { return tier.tierId === currentTierId; });
    var startLabel = '';
    var endLabel = '';
    var percentage = perkCurrentTierProgressPercentage;
    if (tierIdx > -1) {
        var currentTier = tiers[tierIdx];
        startLabel = currentTier.minThresholdDisplay;
        endLabel = currentTier.maxThresholdDisplay;
        percentage = currentTier.progressPercentage;
    }
    var accrualData = perksInfo === null || perksInfo === void 0 ? void 0 : perksInfo.accrualData[0];
    var viewingPxcc = pxccUserCategory === 'Enrolled';
    var _f = accrualData || {}, spendForNextPerk = _f.spendForNextPerk, spendForNextPerkWithPxcc = _f.spendForNextPerkWithPxcc, finalTierPerkAchieved = _f.finalTierPerkAchieved, accrual = _f.accrual, acceleratedAccrual = _f.acceleratedAccrual;
    var spend = spendForNextPerk;
    if (viewingPxcc) {
        spend = spendForNextPerkWithPxcc;
    }
    var amount = floorNumberWithCommas(spend || 0, 0);
    var userBenefitTags = (_a = rewardsAndOffers === null || rewardsAndOffers === void 0 ? void 0 : rewardsAndOffers.proTiers) === null || _a === void 0 ? void 0 : _a.benefitTags;
    var pab = userBenefitTags &&
        (userBenefitTags === null || userBenefitTags === void 0 ? void 0 : userBenefitTags.find(function (tag) {
            return tag.tagName === 'ProAccountBlueprint';
        }));
    var isPab = pab !== undefined;
    var showHistory = !isPab && !isChildAccount;
    var cardTitle = "Your Next Perk";
    var cardProps = {
        title: cardTitle,
        dataTestID: 'perkTracker',
        FooterButton: function (props) { return (React.createElement(PerkTrackerCTA, __assign({ isMobile: isMobile, showHistory: showHistory, finalTierPerkAchieved: finalTierPerkAchieved }, props))); },
    };
    if (hasError || generalError)
        return (React.createElement(RewardCardContainer, __assign({ isMobile: isMobile }, cardProps),
            React.createElement(ErrorTrackerTile, { refreshPerks: refreshPerks })));
    if (finalTierPerkAchieved)
        return (React.createElement(RewardCardContainer, __assign({ isMobile: isMobile }, cardProps),
            React.createElement(WellDoneTrackerTile, { firstName: firstName })));
    return (React.createElement(RewardCardContainer, __assign({ isMobile: isMobile }, cardProps),
        React.createElement(ProgressTrackerTile, { amount: amount, accrual: accrual, acceleratedAccrual: acceleratedAccrual, percentage: percentage, startLabel: startLabel, endLabel: endLabel, isMobile: isMobile, viewingPxcc: viewingPxcc, isPab: isPab })));
};
